import HomeGhLobbyRail from './HomeGhLobbyRail';

/** Home casino rail — mirrors /casino slots (GhStyleLobby). */
export default function HomeSlotsRails({ onNavigate, insertAfterPopular = null }) {
  return (
    <>
      <HomeGhLobbyRail lobby="slots" onNavigate={onNavigate} />
      {insertAfterPopular}
    </>
  );
}
